import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { centerAll } from "../../../../actions";

class CenterAll extends React.Component {
  handleClick = () => {
    this.props.centerAll();
  };

  render() {
    return (
      <div className="tool tool--alignitems">
        <h4 className="tool__header">Align All</h4>
        <div className="tool__options">
          <a
            className="tool__option tool__option--align tool__option--align-tocenter"
            onClick={this.handleClick}
          >
            <div className="icon-align__icon">
              <div className="icon-align__svg">
                <svg
                  className="icon-align icon-align__center"
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    stroke="#37455A"
                    strokeWidth="2"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinecap="round"
                  >
                    <path d="M25.432 13H1M13 25.432V1" />
                  </g>
                </svg>
              </div>
              <div className="icon-align__text">Center All</div>
            </div>
          </a>
        </div>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      centerAll,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CenterAll);
